export default "__VITE_PUBLIC_ASSET__1a3695fe__"